import React, { useEffect, useState } from 'react';
import { showError, sortArray } from 'utils';
import _ from 'lodash';
import { fetchAllSalesChannels } from 'services/api/salesChannel';
import MultiSelectDropdown from './MultiSelectDropdown';

const SalesChannelsMultiSelect = props => {
  const [salesChannels, setSalesChannels] = useState<Record<string, any>[]>([]);
  const [loading, setLoading] = useState(false);

  const {
    value = [],
    onChange,
  } = props;

  const fetchAllSalesChannelFn = async () => {
    try {
      setLoading(true);
      const response = await fetchAllSalesChannels();
      setSalesChannels(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllSalesChannelFn();
  }, []);

  const sanitizedSalesChannelsForPicker = salesChannels?.map((channel)=>{
    return {
      label: channel?.name,
      value: channel?.objectId,
    };
  });
  
  return (
    <MultiSelectDropdown
      isTableCell={false}
      value={value}
      options={sanitizedSalesChannelsForPicker}
      onChange={onChange}
      disableSearch={true}
      disabled={loading}
    />
  );
};

export default SalesChannelsMultiSelect;